import { createRouteFor } from '@components-common/routes';
export const sectionBase = "courses";
export const routeId = ":courseId";
export const routeIdBase = `${sectionBase}/:courseId`;
export const basePath = sectionBase;

export const dashboard = `/${routeIdBase}/dashboard`;
export const people = `/${routeIdBase}/people`;
export const resources = `/${routeIdBase}/resources`;
export const assignments = `/${routeIdBase}/assignments`;

export const groups = `${routeIdBase}/groups`;

const routesForCourses = createRouteFor<typeof routeIdBase,"courses">(routeIdBase,"courses");

export const coursesRoutes = {
  index: routesForCourses("index",{basePath:""}),
  create: routesForCourses("create",{basePath:""}),
  details: routesForCourses("details",{basePath:":courseId"}),
}

export type CoursesRoutesIds = typeof coursesRoutes[keyof typeof coursesRoutes]["id"];
